import { log2 } from "../../utils/log2";

const log = log2("store.zoho");

const zoho = {
    namespaced: true,
    state: {
        selectedDeals: [],
    },
    getters: {},
    mutations: {
        SET_SELECTED_DEALS(state, dealIds) {
            state.selectedDeals = dealIds;
        },
    },
    actions: {
        async setSelectedDeals({ commit }, payload) {
            commit("SET_SELECTED_DEALS", payload);
        },
    },
};

export default zoho;
